import { routerRedux } from 'dva/router';
import { reloadAuthorized } from 'utils/Authorized';
import {
  getAccessToken,
  setAccessToken,
  setRefreshToken
} from 'utils/sessionToken';
import { getDataPlatformPermission, getTenantContext } from 'src/services/cedar';
import { setPermissionCodeList, useUser, useTenantsContext, getUserPermission } from '../common/gobalState';
import { getAppUrl, getSSOLogoutUrl } from '../utils/sso';
import { getUserPersonId, getUserTenantId } from 'src/utils/tenantContext';
import { formatPermissionObj } from 'src/utils/utils';
import { convertContext } from 'src/gs-utils/core/utils';

function* fetchTenantsContext(_, { call, put }) {
  try {
    const res = yield call(getTenantContext);
    if(res.code === 0){
      const contextData = convertContext(res.data);
      yield put({
        type: 'changeTenantsContext',
        payload: contextData,
      });
      const [, setTenants] = useTenantsContext();
      const [, setUser] = useUser();
      setTenants(contextData);
      setUser({
        email: contextData.person.contactEmail,
      });
      yield put({
        type: 'changeCurrentUser',
        payload: {
          email: contextData.person.contactEmail,
        },
      });
      yield put({
        type: 'changeLoginStatus',
        payload: {
          status: true,
        },
      });
      reloadAuthorized();
    } else {
      yield put({
        type: 'logout',
      });
      throw Error(i('获取租户信息失败'));
    }
  } catch (err) {
    console.error('fetch tenants context Error', err);
    // yield put(routerRedux.replace('/exception/500')); safari info接口报错，页面空白
  }
}

function* fetchDataPlatformPermission(_, { call }) {
  try {
    const personId = getUserPersonId();
    const tenantId = getUserTenantId();
    const [user] = useUser();
    const { email } = user;
    const { permissions } = yield call(getDataPlatformPermission, { personId, tenantId });
    let permissionList = [];
    if (Array.isArray(permissions)) {
      if(permissions.length === 0) {
        window.location.href = `${window.location.origin}#/exception/403`;
      }
      permissionList = formatPermissionObj(permissions, "");
    }
    if (!!permissionList?.length ) {
      const dataPlatformPermission = {};
      permissionList.forEach(v => {
        dataPlatformPermission[v] = true
      })
      // const permissionObj = Object.assign({}, cloudPermission, dataPlatformPermission);
      console.log('dataPlatformPermission', dataPlatformPermission)
      const permissionObj = Object.assign({}, dataPlatformPermission);
      setPermissionCodeList(permissionObj);
    }
  } catch(err) {
    console.log('err', err)
  }
}

export default {
  namespace: 'login',

  state: {
    status: false,
    session: '',
    accessToken: '',
    refreshToken: '',
    errMsg: '',
    isSecurityCodeRequired: false,
    securityCodeImg: '',
    currentUser: {
      nickName: '',
      granted: 'ADMIN',
      email: '',
      companyCode: '',
      phoneNumber: '',
      jiraAccount: '', // jira 用户名
      jiraPassword: '', // jira 密码
    },
    tenantsContext: null
  },

  effects: {
    *fetchAccountInfo(_, { call, put, select }) {
      yield fetchTenantsContext(_, { call, put });
      yield fetchDataPlatformPermission(_, { call });
    },
    *logout(_, { }) {
      setAccessToken('');
      setRefreshToken('');
      window.location.href = getSSOLogoutUrl();
    },
  },

  reducers: {
    changeErrMsg(state, { payload }) {
      return {
        ...state,
        errMsg: payload || '',
      };
    },
    changeIsSecurityCodeRequired(state, { payload }) {
      return {
        ...state,
        isSecurityCodeRequired: payload || false,
      };
    },
    changeSecurityCodeImg(state, { payload }) {
      return {
        ...state,
        securityCodeImg: payload || '',
      };
    },
    changeCurrentUser(state, { payload }) {
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          ...payload,
        },
      };
    },
    changeLoginStatus(state, { payload }) {
      return {
        ...state,
        status: payload.status,
        errMsg: '',
      };
    },
    changeSession(state, { payload }) {
      return {
        ...state,
        session: payload.session,
        accessToken: payload.accessToken
      };
    },
    changeAccessToken(state, { payload }) {
      return {
        ...state,
        accessToken: payload.accessToken
      };
    },
    changeRefreshToken(state, { payload }) {
      return {
        ...state,
        refreshToken: payload.refreshToken
      };
    },
    changeTenantsContext(state, { payload }) {
      return {
        ...state,
        tenantsContext: payload
      };
    }
  },
};
